import { render, staticRenderFns } from "./vueHighlight.vue?vue&type=template&id=bcf86dea"
import script from "./vueHighlight.vue?vue&type=script&lang=js"
export * from "./vueHighlight.vue?vue&type=script&lang=js"
import style0 from "./vueHighlight.vue?vue&type=style&index=0&id=bcf86dea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports